
import request from '../utils/request'
const { ocpSaasPath } = window.globalConfig;
export default class DepartmentApi {
  /**
   * 查询部门
   * @param params
   * @returns {*|Promise<*>}
   */
  static query = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/queryDeptByPage`, params)
  }
  // POST /api/0 / dept / queryDeptAndUserManagerList
  /**
   * 查询部门及负责人信息
   * @param params
   * @returns {*|Promise<*>}
   */
  static queryDeptAndUserManagerList = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/queryDeptAndUserManagerList`, params)
  }
  /**
   * 创建部门
   * @param params
   * @returns {*|Promise<*>}
   */
  static create = (params, config) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/create`, params, config)
  }
  /**
   * 删除部门
   * @param params
   * @returns {*|Promise<*>}
   */
  static delete = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/delete`, params)
  }
  /**
 * 更新部门
 * @param params
 * @returns {*|Promise<*>}
 */
  static update = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/update`, params)
  }
  /**
   * 查询所有机构部门树 POST /api/0/dept/getDeptForTree
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDeptForTree = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/getDeptForTree`, params)
  }
  /**
     * 通过部门id查询人或者负责人 POST /api/0/dept/getDeptForTree
     * @param params
     * @returns {*|Promise<*>}
     */
  static findUserByDeptId = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/user/findUserByDeptId`, params)
  }

  /**
   * 查询部门的所有用户
   * @param params
   * @returns {*|Promise<*>}
   */
  static queryRoleUserByIds = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/queryRoleUserByIds`, params)
  }
  /**
   * 部门查询
   * @param params
   * @returns {*|Promise<*>}
   */
  static queryRoles = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/queryRoles`, params)
  }
  /**
   * 分配部门资源
   * @param params
   * @returns {*|Promise<*>}
   */
  static awarded = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/awardedRoleResource`, params)
  }

  /**
   * 根绝部门标识符查询部门的所有用户
   * @param params
   * @returns {*|Promise<*>}
   */
  static queryRoleUserByIdentifier = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/dept/queryUserByStationRoleAndIdentifier`, params)
  }

  /**
   * 根据厂站id获取用户信息
   * @param params
   * @returns {*|Promise<*>}
   */
   static getUserByStationId = (stationId) => {
    return request.appid(`/${ocpSaasPath}/api/0/user/getUserByStationId?stationId=${stationId}`)
  }

  /**
   * 根据部门id获取部门负责人
   * @param params
   * @returns {*|Promise<*>}
   */
  static getDeptHeadersByDeptId = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/user/getDeptHeadersByDeptId`,params)
  }

  /**
   * 新增部门负责人
   * @param params
   * @returns {*|Promise<*>}
   */
  static addDeptHeader = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/user/addDeptHeader`, params)
  }

  /**
   * 移除部门负责人
   * @param params
   * @returns {*|Promise<*>}
   */
  static delDeptHeader = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/user/delDeptHeader`, params)
  }

  /**
   * 获取部门下所有人
   * @param params
   * @returns {*|Promise<*>}
   */
  static getUsersByDeptId = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/user/getUsersByDeptId`, params)
  }

  /**
   * 用户列表
   * @param params
   * @returns {*|Promise<*>}
   */
   static pageListAll = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/user/pageListAll`, params)
  }

  /**
   * 更新钉钉用户
   * @param params
   * @returns {*|Promise<*>}
   */
   static updateDingUserId = (params) => {
    return request.post(`/${ocpSaasPath}/api/0/user/updateDingUserId`, params)
  }

}
